import { Box as Native } from "@chakra-ui/react"
import { UI } from "components"

export default function({ colorPalette = 'bg', loading = false, ...props }){

    const backgroundColor = `${colorPalette}.muted`

    if(loading) return <Native w="100%">
        <UI.Skeleton.Skeleton w="100%" minH="180px" />
    </Native>

    return <Native p={4} h="100%" borderRadius={4} backgroundColor={backgroundColor} {...props} />
}